module.exports = __webpack_public_path__ + "static/media/piano-d.436f6422.wav";